import { render, staticRenderFns } from "./AmendmentDocument.vue?vue&type=template&id=6031b78e&scoped=true"
import script from "./AmendmentDocument.vue?vue&type=script&lang=js"
export * from "./AmendmentDocument.vue?vue&type=script&lang=js"
import style0 from "./AmendmentDocument.vue?vue&type=style&index=0&id=6031b78e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031b78e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6031b78e')) {
      api.createRecord('6031b78e', component.options)
    } else {
      api.reload('6031b78e', component.options)
    }
    module.hot.accept("./AmendmentDocument.vue?vue&type=template&id=6031b78e&scoped=true", function () {
      api.rerender('6031b78e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/amendment/AmendmentDocument.vue"
export default component.exports